import { Box } from "@mui/material";
import { css } from "styled-components"
import { styled as muiStyled } from '@mui/material/styles';
import { fontWeight } from "@mui/system";

const WrapCreateAffiliation = css`

display: grid;
grid-template-columns: 50% 50%;
grid-gap: 15px;

`


export const CreateAffiliationStyles = muiStyled(Box)(({ theme }) => ({
    width: 550,
    '.section-fields': {
        flexWrap: "wrap",
        display: "flex",
        rowGap: 15,
        columnGap: 15,
        marginBottom: 20,
        width: "100%"
    },
    '.section-title': {
        marginBottom: 10,
        fontWeight: "bold"
    },
    '.form-field': {
        flexGrow: 1
    }
}));

export { WrapCreateAffiliation }